import type { GetIsActiveSidebarItemParams } from '../types';

const getIsActiveSidebarItem = ({
    pathname,
    basePath,
    itemPath,
    itemKey,
}: GetIsActiveSidebarItemParams): boolean => {
    if (itemKey === 'overview') {
        return pathname === basePath || pathname === `${basePath}/`;
    }

    return pathname === `${basePath}/${itemPath}`;
};

export default getIsActiveSidebarItem;
